export enum LocalizationColumns {
    Language = 'language',
    PrivacyCenterVisibility = 'privacyCenterVisibility',
  }